import { Modal } from "@mui/material";
import SiteHeader from "app/SiteHeader";
import Page404 from "app/not-found";
import InitialLoadingAnimationLottie from "components/LoadingAnimationLottie/initialLoading";
import { useDocumentLoading } from "hooks/useDocumentLoading";
import { Suspense, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { showPopup } from "redux-store/reducers/userReducer";
import { useSelectors } from "redux-store/selectors";
import {
  DashboardBilingAddress,
  DashboardEditProfile,
  DashboardPosts,
  DashboardSubcription,
  DashboardSubmitPost,
  Followers,
  Followings,
  ManageInterests,
  MyAccount,
  PageAuthor,
  PageHomeDemo6,
  PageLogin,
  PageSignUp,
  PageSingle,
  Stats,
  Stories,
  TopicDetails,
  Write,
  WriterApplicationForm,
} from "./LazyLoadedComponent";
import { Page } from "./types";

const routes: Page[] = [
  { path: "/", component: PageHomeDemo6 },
  { path: "/stats", component: Stats },
  // { path: "/leaderboard", component: Leaderboard },
  { path: "/author/:username/:userId", component: PageAuthor },
  { path: "/dashboard", component: DashboardSubmitPost },
  { path: "/dashboard/posts", component: DashboardPosts },
  { path: "/dashboard/edit-profile", component: DashboardEditProfile },
  { path: "/dashboard/subscription", component: DashboardSubcription },
  { path: "/dashboard/billing-address", component: DashboardBilingAddress },
  { path: "/dashboard/submit-post", component: DashboardSubmitPost },
  { path: "/followers", component: Followers },
  { path: "/followings", component: Followings },
  { path: "/write", component: Write },
  { path: "/write/:articleId", component: Write },
  { path: "/my-account/:text", component: MyAccount },
  {
    path: "/article/:username/:articleTitle/:articleId",
    component: PageSingle,
  },
  { path: "/manage-interests", component: ManageInterests },
  { path: "/stories", component: Stories },
  { path: "/topic/:tagName", component: TopicDetails },
  { path: "/become-a-writer", component: WriterApplicationForm },
  { path: "/", component: PageLogin },
  { path: "/login", component: PageLogin },
  { path: "/signup", component: PageSignUp },
];

const MyRoutes = () => {
  const dispatch = useDispatch();
  const { authPopup } = useSelectors();
  const { documentLoading } = useDocumentLoading();
  const [loginPageOpen, setLoginPageOpen] = useState(true);
  const [open, setOpen] = useState(authPopup);

  const handleClose = () => {
    dispatch(showPopup(false));
  };

  useEffect(() => {
    setOpen(authPopup);
  }, [authPopup]);

  useEffect(() => {
    return () => {
      dispatch(showPopup(false));
    };
  }, [dispatch]);

  if (documentLoading) {
    return (
      <div className="flex justify-center items-center h-[100vh]">
        <InitialLoadingAnimationLottie width={300} height={300} />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Modal
        open={open}
        onClose={handleClose}
        className="transition-opacity duration-500 ease-in-out opacity-0 hover:opacity-100"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {loginPageOpen ? (
          <PageLogin setLoginPageOpen={setLoginPageOpen} isModalOpen={true} />
        ) : (
          <PageSignUp setLoginPageOpen={setLoginPageOpen} isModalOpen={true} />
        )}
      </Modal>
      <SiteHeader />
      <Suspense
        fallback={<InitialLoadingAnimationLottie width={300} height={300} />}
      >
        <Routes>
          {routes.map(({ component: Component, path }, index) => {
            return <Route key={index} element={<Component />} path={path} />;
          })}
          <Route element={<Page404 />} path="*" />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default MyRoutes;
